
interface TinyMCESettings {
  readonly menubar: boolean;
  readonly inline: boolean;
  readonly toolbar: boolean;
  readonly plugins: string[];
  readonly formats: any;
  readonly quickbars_selection_toolbar: string;
  readonly quickbars_insert_toolbar: boolean;
  readonly invalid_elements: string;
  readonly entity_encoding: string;
  readonly paste_as_text: boolean;
  readonly skin: any;
  readonly selector: string;
  readonly setup: any;
}

const ENTER_KEY = 13;

export namespace TinyEditorConfigs {

  export const welcomeChannelEditor = (selector: string, onKeyPressCallback: (charCount: number, newLineCount: number) => void) => {

    let tinyEditor: any = null;   // Initialized in TinyMCE setup. Don't want to create anonymous function in editor.on()
    let textBeforeExecCommand: String;

    const getCharacterCount = () => {
      const content = tinyEditor.getContent({ format: 'text' });
      const cleaned = content.replace(/\n/g, ''); // Ignore new line characters
      return cleaned.length;
    };

    const getNewLineCount = () => {
      const html = tinyEditor.getContent({ format: 'raw' });
      return (html.match(/<p>/gm) || []).length;
    };

    const preventShiftEnter = (event: any) => {
      if (event.keyCode === ENTER_KEY && event.shiftKey) {
        event.preventDefault();
        event.stopPropagation();
        return false;
      }
    };

    const handleKeyPress = (event: any) => {
      const charCount = getCharacterCount();
      const newLineCount = getNewLineCount();
      onKeyPressCallback(charCount, newLineCount);
      preventShiftEnter(event);
    };

    const makeCopyOfTinyEditorContent = (event: any) => {
      textBeforeExecCommand = tinyEditor.getContent({ format: 'text' });
    };

    // TFS 957595 when Adding hyperlink trims surrounding space (chrome/windows)
    const handleLinkMissingSpace = (event: any) => {
      const textAfterExecCommand: String = tinyEditor.getContent({ format: 'text' });
      const htmlAfterExecCommand: String = tinyEditor.getContent({ format: 'html' });
      if (textBeforeExecCommand.length > textAfterExecCommand.length) {
        // devnote: even though I am adding multiple spaces on the first occurrence it displays as one on the editor
        // and all off the spaces get deleted with a single backspace
        tinyEditor.setContent(htmlAfterExecCommand.replace(/<\/a>/gm, '</a> '));
      }
    };

    const settings: TinyMCESettings = {
      menubar: false,
      inline: true,
      toolbar: false,
      plugins: [
        'autolink',
        'link',
        'paste',
        'quickbars',
      ],
      formats: {    // Disables keyboard shortcuts by rendering them useless
        bold: {inline: 'span', 'classes': 'bold'},
        underline: { inline: 'span', 'classes': 'underline' },
        italic: { inline: 'span', 'classes': 'italic' }
      },
      invalid_elements: 'span',
      quickbars_selection_toolbar: 'quicklink',
      quickbars_insert_toolbar: false,
      entity_encoding: 'raw', // Prevents trailing spaces from being marked as &nbsp;
      paste_as_text: true,
      skin: false,  // Prevents tinyMCE from loading the default Oxide skin, which is not used by the inline editor
      selector,
      setup: (editor: any) => {
        tinyEditor = editor;
        editor.on('SetContent', handleKeyPress);
        editor.on('keydown', handleKeyPress);
        editor.on('keyup', handleKeyPress);
        editor.on('BeforeExecCommand', makeCopyOfTinyEditorContent);
        editor.on('ExecCommand', handleLinkMissingSpace);
      },
    };
    return settings;
  };
}
